import { ListItem, ListItemAvatar, ListItemProps, ListItemText } from '@mui/material';
import { AvatarIcon } from '../Avatar/AvatarIcon';

interface NotYetListItemProps extends ListItemProps {
  icon: React.ReactNode;
  title: string;
}

export function NotYetListItem({ icon, title, ...props }: NotYetListItemProps) {
  return (
    <ListItem {...props}>
      <ListItemAvatar>
        <AvatarIcon icon={icon} />
      </ListItemAvatar>
      <ListItemText primary={title} slotProps={{ primary: { color: 'textSecondary' } }} />
    </ListItem>
  );
}
